/* Gesamtzahl der Living-Root-Bewertungen live von reviews.io holen.

   EINE QUELLE FUER ALLE ANZEIGEN. Die Zahl steht an zwei Stellen: in der Box
   ueber dem Produktnamen (snippets/lr-badge.liquid) und im schwebenden
   Abzeichen unten rechts (snippets/lr-reviews-badge.liquid). Beide werden von
   hier aus bedient – einmal ueber die data-Attribute, einmal ueber das Event
   "lr:reviews". Zwei getrennte Abfragen haetten zwei verschiedene Zahlen auf
   derselben Seite ergeben, und genau das ist vorher passiert (104 gegen 107).

   WARUM NICHT AUS DEN SHOPIFY-METAFELDERN?
   Die reviews.io-App schreibt pro Produkt reviewscouk.total. Fuer Reset C (29)
   und Clean Flam (28) stimmt der Wert, fuer Basic Gold stand dort 44, waehrend
   reviews.io selbst nur 22 Produktbewertungen kennt – also genau das Doppelte.
   Neben dem Pruefsiegel "geprueft durch reviews.io" darf keine hoehere Zahl
   stehen als die, die reviews.io selbst ausweist (§ 5 UWG, Anhang zu § 3
   Abs. 3 UWG Nr. 23b). Deshalb fragen wir die Quelle direkt.

   HAUPTQUELLE ist seit dem 16.09.2026 der Timeline-Endpunkt. Der liefert die
   shopweite Gesamtzahl, so wie reviews.io sie selbst fuehrt – inklusive aller
   Produktbewertungen, auch von SKUs, die unten nicht aufgelistet sind. Genau
   daran ist die alte Rechnung gescheitert: Sie addierte Produkt- und
   Shopbewertungen anhand einer festen SKU-Liste und zaehlte drei Bewertungen
   nicht mit, weil eine SKU fehlte.

   ERSATZWEG bleibt die alte Summe aus zwei Endpunkten, falls die Timeline
   nicht antwortet. Sie liegt eher zu niedrig als zu hoch, und das ist die
   richtige Richtung fuer den Fehlerfall.

   Ergebnis wird 12 Stunden im sessionStorage gehalten, damit nicht jeder
   Seitenaufruf Requests ausloest. Faellt alles aus, bleibt der serverseitig
   gerenderte Stand stehen – der ist nie zu hoch, weil die Zahl nur waechst.

   SKU-Liste nur noch fuer den Ersatzweg relevant. */
(function () {
  var SKUS = 'LR_BGC_EP;LR_RCC_EP;LR_CFC_EP;LR_BNDL_BC_CFC_RCC';
  var STORE = 'livingroot.de';
  var KEY = 'lr_reviews_total_v2';
  var MAX_AGE = 12 * 60 * 60 * 1000;

  function emit(count, rating) {
    window.LR_REVIEWS = { count: count, rating: rating };
    try {
      document.dispatchEvent(new CustomEvent('lr:reviews', {
        detail: { count: count, rating: rating }
      }));
    } catch (e) { /* alte Browser – data-Attribute sind trotzdem gesetzt */ }
  }

  function paint(count, rating) {
    if (!count) return;
    var i;
    var c = document.querySelectorAll('[data-lr-rev-count]');
    for (i = 0; i < c.length; i++) c[i].textContent = count;

    if (rating) {
      var r = document.querySelectorAll('[data-lr-rev-rating]');
      var txt = rating.toFixed(2).replace('.', ',');
      for (i = 0; i < r.length; i++) r[i].textContent = txt;

      var s = document.querySelectorAll('[data-lr-rev-stars]');
      var pct = Math.max(0, Math.min(100, (rating / 5) * 100));
      for (i = 0; i < s.length; i++) s[i].style.width = pct.toFixed(1) + '%';
    }

    emit(count, rating);
  }

  function cached() {
    try {
      var raw = sessionStorage.getItem(KEY);
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > MAX_AGE) return null;
      return o;
    } catch (e) { return null; }
  }

  function store(count, rating) {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ c: count, r: rating, t: Date.now() }));
    } catch (e) { /* privater Modus – egal */ }
  }

  function ersatzweg() {
    var pUrl = 'https://api.reviews.io/product/review?store=' + STORE +
               '&sku=' + encodeURIComponent(SKUS) + '&per_page=1';
    var mUrl = 'https://api.reviews.io/merchant/latest?store=' + STORE + '&per_page=1';

    return Promise.all([
      fetch(pUrl).then(function (r) { return r.json(); }),
      fetch(mUrl).then(function (r) { return r.json(); })
    ]).then(function (res) {
      var ps = (res[0] && res[0].stats) || {};
      var ms = (res[1] && res[1].stats) || {};
      var pc = parseInt(ps.count, 10) || 0;
      var pa = parseFloat(ps.average) || 0;
      var mc = parseInt(ms.total_reviews, 10) || 0;
      var ma = parseFloat(ms.average_rating) || 0;
      var total = pc + mc;
      if (!total) return;
      var avg = (pc * pa + mc * ma) / total;
      paint(total, avg);
      store(total, avg);
    });
  }

  function load() {
    var hit = cached();
    if (hit) { paint(hit.c, hit.r); return; }

    fetch('https://api.reviews.io/timeline/data?store=' + STORE + '&per_page=1')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var st = (d && d.stats) || {};
        var total = parseInt(st.review_count || st.results_count, 10) || 0;
        var avg = parseFloat(st.average_rating) || 0;
        if (!total) throw new Error('leer');
        paint(total, avg);
        store(total, avg);
      })
      .catch(function () {
        return ersatzweg();
      })
      .catch(function () { /* Serverseitiger Stand bleibt stehen */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', load);
  } else {
    load();
  }
})();
